import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { OrganizationModels } from '@share-models';

export const OrganizationActions = createActionGroup({
  source: 'ORGANIZATION',
  events: {
    'Reset to Initial state': emptyProps(),
    'Get Active Organization': emptyProps,
    'Set Active Organization Document': props<{
      activeOrganizationDocument: OrganizationModels.OrganizationDocument;
    }>(),
    'Get My Organizations': emptyProps(),
    'Get My Organizations Success': props<{
      userOrganizations: OrganizationModels.UserOrganizationDropDown[];
    }>(),
    'Get My Organizations Fail': emptyProps(),
  },
});
